export const informacionBasicaTypes = {
    INFO_BASICA_SAVE_START: '[InfoBasica] SAVE_START',
    INFO_BASICA_SAVE_COMPLETE: '[InfoBasica] SAVE_COMPLETE',
    INFO_BASICA_SAVE_ERROR: '[InfoBasica] SAVE_ERROR',
    INFO_BASICA_VALIDATED: '[InfoBasica] VALIDATED',
    INFO_BASICA_UPDATED: '[InfoBasica] UPDATED',
}